(function () {
  var script = document.currentScript;
  var productDocumentDestination = 'AW-621069237/9b3GCPe3zdccELWHk6gC';
  var designTemplateDestination = 'AW-621069237/bTh_CLbfzdccELWHk6gC';
  var productContext = {
    page_kind: script ? script.dataset.pageKind : '',
    template_library: script ? script.dataset.templateLibrary === 'true' : false,
    product_id: script ? script.dataset.productId : '',
    product_handle: script ? script.dataset.productHandle : '',
    product_title: script ? script.dataset.productTitle : '',
    language: script ? script.dataset.language : ''
  };

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () {
    window.dataLayer.push(arguments);
  };

  document.addEventListener('click', function (event) {
    var target = event.target;
    var link = target && typeof target.closest === 'function'
      ? target.closest('a[href]')
      : null;

    if (!link) {
      return;
    }

    var rawHref = link.getAttribute('href') || '';
    var linkText = (link.textContent || '').trim();
    var isPdf = /\.pdf(?:[?#]|$)/i.test(rawHref);
    var isTemplateFile = /\.(?:zip|ai|eps)(?:[?#]|$)/i.test(rawHref);
    var isTemplateLink = productContext.template_library
      ? isPdf || isTemplateFile
      : isTemplateFile || /template/i.test(linkText);

    if (!isPdf && !isTemplateFile) {
      return;
    }

    var documentDetails = {
      page_kind: productContext.page_kind,
      product_id: productContext.product_id,
      product_handle: productContext.product_handle,
      product_title: productContext.product_title,
      language: productContext.language,
      file_url: link.href,
      link_text: linkText
    };

    if (isTemplateLink) {
      window.gtag('event', 'design_template_download', documentDetails);
      if (window.EzupAnalytics && typeof window.EzupAnalytics.trackCustomEvent === 'function') {
        window.EzupAnalytics.trackCustomEvent('DesignTemplateDownload', documentDetails);
      }
      window.gtag('event', 'conversion', {
        send_to: designTemplateDestination,
        value: 0.0,
        currency: 'CAD'
      });
      return;
    }

    window.gtag('event', 'product_document_download', documentDetails);
    if (window.EzupAnalytics && typeof window.EzupAnalytics.trackCustomEvent === 'function') {
      window.EzupAnalytics.trackCustomEvent('ProductDocumentDownload', documentDetails);
    }
    window.gtag('event', 'conversion', {
      send_to: productDocumentDestination,
      value: 0.0,
      currency: 'CAD'
    });
  }, true);
})();
